var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "alive-nav-content" },
    [
      _c(
        "div",
        { staticClass: "left" },
        _vm._l(_vm.visitedTabsView, function (tag) {
          return _c(
            "div",
            {
              key: tag.path,
              staticClass: "tags-view-item",
              on: {
                click: function ($event) {
                  return _vm.go(tag.path)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "tag flex_c_c",
                  class: [{ active: _vm.isActive(tag) }],
                },
                [
                  _c("span", [_vm._v(_vm._s(tag.name))]),
                  _c(
                    "span",
                    {
                      staticClass: "closebox flex_c_c",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleClose(tag)
                        },
                      },
                    },
                    [
                      _c("svg-icon", {
                        attrs: { iconClass: "close", className: "icon" },
                        on: {
                          iconClick: function ($event) {
                            return _vm.handleClose(tag)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        }),
        0
      ),
      _c("div", { staticClass: "opt" }, [
        _c("div", { staticStyle: { display: "flex" } }, [
          _c(
            "div",
            {
              staticClass: "item",
              attrs: { title: "刷新" },
              on: { click: _vm.reload },
            },
            [
              _c("i", {
                staticClass: "el-icon-refresh-right",
                staticStyle: { "font-size": "20px", color: "#fff" },
              }),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "item",
              on: {
                click: function ($event) {
                  _vm.drawer = true
                },
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-user",
                staticStyle: { "font-size": "20px", color: "#fff" },
              }),
            ]
          ),
        ]),
      ]),
      _c("upcome-drawer"),
      _c("message-drawer"),
      _c("UserDrawer", {
        attrs: { drawer: _vm.drawer },
        on: {
          close: function ($event) {
            _vm.drawer = false
          },
          exit: _vm.exit,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }